import { usePayWithPoints } from "../../../services/hooks/loyalty/usePayWithPoints";
import { useTranslationI18 } from "../../../services/hooks/useTranslationI18";
import { PayWithPointsBanner } from "./PayWithPointsBanner";
import styles from "./PayWithPointsSection.module.scss";

type PayWithPointsSectionProps = {
  onHowItWorks: () => void;
};

export const PayWithPointsSection = ({
  onHowItWorks,
}: PayWithPointsSectionProps) => {
  const { t } = useTranslationI18();
  const { isEnabled, isSignedIn } = usePayWithPoints("browse");

  if (!isEnabled) {
    return null;
  }

  return (
    <div className={styles.section} data-testid="pay-with-points-section">
      <div className={styles.title_bar}>
        <h3 className={styles.title}>{t("pointing-system:pay-with-points")}</h3>
        <button
          type="button"
          className={styles.how_it_works}
          onClick={onHowItWorks}
          data-testid="pwp-how-it-works"
        >
          {t("pointing-system:how-it-works")}
        </button>
      </div>

      {!isSignedIn && (
        <span className={styles.subtitle}>
          {t("pointing-system:check-your-total")}
        </span>
      )}

      {/* ----------------------Read-only on the rewards tab: the drawer is opened from the cart, where there is a bill to discount----------------------- */}
      <PayWithPointsBanner variant="rewards" surface="browse" />
    </div>
  );
};
